import React, { useEffect, useState } from 'react';
import { DropdownOption, SelectedOptionId } from './types';
import { DropdownView } from './view';
import { usePrevious } from '../../utils/hooks';
import { DeviceType } from '../../types/DeviceType';

export interface DropdownControllerProps {
  deviceType?: DeviceType;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  invalid?: boolean;
  inputTextValue?: string;
  selectedOptionId?: SelectedOptionId;
  placeholder?: string;
  options: DropdownOption[];

  onSelect(selectedOption: DropdownOption): void;
}

export const DropdownController: React.FC<DropdownControllerProps> = (
  props
) => {
  const {
    deviceType,
    options,
    placeholder,
    inputTextValue,
    label,
    invalid,
    required,
    disabled,
    onSelect,
    selectedOptionId: selectedOptionIdFromProps,
  } = props;

  const [isOptionsListOpened, setIsOptionsListOpened] = useState(false);
  const [selectedOptionId, setSelectedOptionId] = useState<SelectedOptionId>(
    selectedOptionIdFromProps
  );

  const handleOptionSelect = (optionToSelect: string) => {
    const selected = options.find(
      (option: DropdownOption) => option.id.toString() === optionToSelect
    );

    if (selected) {
      setIsOptionsListOpened(false);
      setSelectedOptionId(selected.id);

      onSelect(selected);
    }
  };

  const prevSelectedOptionId = usePrevious(selectedOptionIdFromProps);
  useEffect(() => {
    if (
      prevSelectedOptionId !== selectedOptionIdFromProps &&
      selectedOptionId !== selectedOptionIdFromProps
    ) {
      setSelectedOptionId(selectedOptionIdFromProps);
    }
  });

  const selectedOption = options.find(
    (option) => option.id === selectedOptionId
  );

  const sharedProps = {
    options,
    placeholder,
    inputTextValue,
    label,
    invalid,
    required,
    disabled,
  };

  return (
    <DropdownView
      {...sharedProps}
      deviceType={deviceType}
      handleOptionSelect={handleOptionSelect}
      selectedOption={selectedOption}
      isOptionsListOpened={isOptionsListOpened}
    />
  );
};
DropdownController.displayName = 'DropdownController';
